import create from "zustand";

interface PurchaseSearchStore {
    searchQuery: string;
    searchContactPurchase: string;
    setContactPurchaseId: (query: string) => void;
    setSearchQuery: (query: string) => void;
    resetSearchQuery: () => void;
}

export const usePurchaseSearchStore = create<PurchaseSearchStore>((set) => ({
    searchQuery: "",
    searchContactPurchase: "",
    setContactPurchaseId: (query) => set({ searchContactPurchase: query }),
    setSearchQuery: (query) => set({ searchQuery: query }),
    resetSearchQuery: () => set({ searchQuery: "" }),
}));
